import { Button } from 'components/Button'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { ReactComponent as CreateLayerIcon } from 'assets/icons/edit16.svg'
import { ButtonProps } from '../Button/Types'

interface Props extends Pick<ButtonProps, 'isDisabled' | 'variant' | 'size' | 'className' | 'frontIcon'> {
  layerId: string
  children?: string
  dataTestId?: string
}

export const EditOnExistingLayerButton = ({
  layerId,
  children = 'Edit on Layer',
  variant,
  isDisabled,
  size,
  className,
  frontIcon = CreateLayerIcon,
  dataTestId,
}: Props) => {
  const history = useHistory()
  const { search } = useLocation()

  const handlePress = () => {
    const searchParams = new URLSearchParams(search)
    searchParams.set('layer', layerId)
    history.push({ search: searchParams.toString() })
  }

  return (
    <Button
      className={className}
      isDisabled={isDisabled}
      frontIcon={frontIcon}
      variant={variant}
      onPress={handlePress}
      size={size}
      data-testid={dataTestId}
    >
      {children}
    </Button>
  )
}
